import type { LossRecordViewRow } from '@/services/lossRecordService';

export type LossTypeLabel = 'FLIPL' | 'Statement of Charges' | 'MFR';

export const getLossTypeLabel = (input: {
  transactionType: LossRecordViewRow['transaction_type'];
  includeContaminationMemo?: boolean | null;
}): LossTypeLabel => {
  if (input.transactionType === 'DA7923') {
    return 'Statement of Charges';
  }
  return input.includeContaminationMemo ? 'MFR' : 'FLIPL';
};
